@let buildingValue = building();
@let buildingReportValue = buildingReport();
@let labelGroupValue = labelGroup();
@let buildingPublicSharedIdValue = buildingPublicSharedId();
@let buildingIdValue = buildingId();
@let portfolioIdValue = portfolioId() ?? buildingValue?.portfolio?.id;
@let hasBuildingReportLicenseValue = hasBuildingReportLicense();
@let canDownloadReportValue = canDownloadReport();
@let hideSelectValue = hideSelect();
@let hideGoToAllBuildingsValue = hideGoToAllBuildings();
@let hideDeleteBuildingValue = hideDeleteBuilding();
@let isLoadingValue = isLoading();
@let hasErrorValue = hasError();
@let errorMessageValue = errorMessage();
@let buildingLabelValue = buildingLabel();
@let roadmapBuildingDetailsValue = roadmapBuildingDetails.value();
@let numberOfLogosValue = numberOfLogos();
@let rowsValue = rows();
@let isPdfServiceRequestValue = isPdfServiceRequest();
@let measureListValue = measureList();
@let buildingMeasuresForExplanationValue = buildingMeasuresForExplanation();
@let partnershipLogoAsBase64Value = partnershipLogoAsBase64();
@if (hasBuildingReportLicenseValue) {
  <cfp-building-report-cover
    [building]="buildingValue"
    [hideSelect]="hideSelectValue || !!buildingPublicSharedIdValue"
    [hideGoToAllBuildings]="hideGoToAllBuildingsValue || !!buildingPublicSharedIdValue"
    [hideDeleteBuilding]="hideDeleteBuildingValue || !!buildingPublicSharedIdValue"
    [canDownloadReport]="canDownloadReportValue || !!buildingPublicSharedIdValue"
    [reportCoverTitle]="reportCoverTitle()"
  />
}
@if (isLoadingValue || hasErrorValue) {
  <cfp-loading-spinner
    [loading]="isLoadingValue"
    [error]="hasErrorValue"
    [errorMessage]="errorMessageValue ? (errorMessageValue | translate) : undefined"
  />
} @else {
  <cfp-printable-content class="building-report-content" data-test="buildingReport">
    <ng-container body>
      <div class="row">
        <div class="col">
          <cfp-building-details-header
            [building]="buildingValue"
            [hideSelect]="hideSelectValue || !!buildingPublicSharedIdValue"
            [hideGoToAllBuildings]="hideGoToAllBuildingsValue || !!buildingPublicSharedIdValue"
            [hideDeleteBuilding]="hideDeleteBuildingValue || !!buildingPublicSharedIdValue"
            [canDownloadReport]="canDownloadReportValue || !!buildingPublicSharedIdValue"
            [hideManageBuildingTags]="!!buildingPublicSharedIdValue"
          />
        </div>
        <div class="col-auto">
          <ng-content select="[headerRight]" />
        </div>
      </div>

      <ng-content />

      @if (portfolioIdValue) {
        <cfp-page-section-building
          class="d-print-none"
          [portfolioId]="portfolioIdValue"
          [buildingId]="buildingIdValue"
          [section]="'REPORT_TOP'"
        />
      }
      @if (buildingValue) {
        <cfp-building-report-buttons
          [canDownloadReport]="canDownloadReportValue"
          [building]="buildingValue"
          [buildingPublicSharedId]="buildingPublicSharedIdValue"
          [labelGroups]="labelGroups()"
          [hasBuildingReportFeedback]="hasBuildingReportFeedback()"
          [reportFileName]="reportPdfFileName()"
          (showFeedback)="showFeedback.emit()"
          (shouldReload)="getAllData()"
        >
          @if (!buildingPublicSharedIdValue && portfolioIdValue) {
            <cfp-page-section-building
              class="col-12 col-lg-auto mt-lg-0 d-print-none"
              [portfolioId]="portfolioIdValue"
              [buildingId]="buildingIdValue"
              [section]="'REPORT_BUILDING_HEADER_ACTIONS'"
            />
          }
        </cfp-building-report-buttons>
      }
      <div class="row print-page-break-inside-avoid">
        <div class="col-12">
          @if (portfolioIdValue) {
            <cfp-building-summary-card
              [building]="buildingValue"
              [buildingLabel]="buildingLabelValue"
              [buildingReport]="buildingReportValue"
              [buildingId]="buildingIdValue"
              [portfolioId]="portfolioIdValue"
              [showSubTitle]="false"
              [showLabel]="showLabelInSummary()"
              [showDescription]="showDescriptionInSummary()"
              [showObjectType]="showObjectTypeInSummary()"
              [showSubObjectType]="showSubObjectTypeInSummary()"
              [class.has-consultant-info]="buildingReportValue?.description && buildingReportValue?.consultant?.name"
            >
              @let consultant = buildingReportValue?.consultant;
              @if (buildingReportValue?.description && consultant?.name) {
                <div class="alert alert-info consultant-info">
                  <h5>{{ 'scanPerformedBy' | translate }}:</h5>
                  <h3>{{ consultant.name }}</h3>
                  @if (consultant.phone) {
                    <div>
                      <i class="fa fa-phone fa-fw text-primary" aria-hidden="true"></i>
                      {{ consultant.phone }}
                    </div>
                  }
                  @if (consultant.email) {
                    <div>
                      <i class="fa fa-envelope fa-fw text-primary" aria-hidden="true"></i>
                      {{ consultant.email }}
                    </div>
                  }
                  <h5 class="mt-2 mb-0 consultant-info-execution-date">
                    {{ 'executionDate' | translate }}: {{ buildingReportValue.checkDate | date: 'longDate' }}
                  </h5>
                  @if (!consultant.userImageId) {
                    <div class="consultant-image consultant-image-none"></div>
                  }
                  @if (consultant.userImageId) {
                    <div
                      class="consultant-image"
                      [style.background-image]="`url(${environment.apiV2}userimages/${consultant.userImageId})`"
                    ></div>
                  }
                </div>
              }
              <ng-content bottom select="[summaryBottom]" />
            </cfp-building-summary-card>
            <cfp-page-section-building
              [portfolioId]="buildingValue.portfolio!.id!"
              [buildingId]="buildingValue.id!"
              [section]="'REPORT_MIDDLE'"
            />
          }
        </div>
      </div>
      <div class="row mt-4 pt-3 print-page-break-inside-avoid">
        <div class="col-12 col-md-6">
          @if (portfolioIdValue) {
            <cfp-building-business-case
              [portfolioId]="portfolioIdValue"
              [buildingId]="buildingIdValue"
              [building]="buildingValue"
              [businessCase]="businessCase.value()"
              [showEnergyUsage]="showEnergyUsageInBusinessCase()"
            />
          }
        </div>
        <div class="col-12 col-md-6">
          <cfp-card>
            <cfp-label-improvement
              [building]="buildingValue"
              [buildingLabel]="buildingLabelValue"
              [labelGroup]="labelGroupValue"
              (labelGroupChange)="labelGroupChange($event)"
            />
          </cfp-card>
        </div>
      </div>

      @if (!buildingPublicSharedIdValue && portfolioIdValue) {
        <cfp-page-section-building
          [portfolioId]="portfolioIdValue"
          [buildingId]="buildingIdValue"
          [section]="'REPORT_BUILDING_BEFORE_MEASURES'"
        />
      }
      @if (
        hasBuildingReportLicenseValue &&
        roadmapBuildingDetailsValue &&
        labelGroupValue &&
        rowsValue &&
        rowsValue?.length > 0
      ) {
        <div class="row mt-4 pt-3 print-page-break-inside-avoid">
          <div class="col-12">
            <cfp-building-report-roadmap-card
              [customRecognizedMeasureIcon]="environment.icons.iconRecognizedMeasure"
              [showRecognisedMeasureCheck]="environment.components.showRecognisedMeasureCheck || false"
              [labelGroup]="labelGroupValue"
              [rows]="rowsValue"
              [currentEnergyLabel]="roadmapBuildingDetailsValue.energyLabels[labelGroupValue]?.currentEnergyLabel"
              [improvedEnergyLabel]="roadmapBuildingDetailsValue.energyLabels[labelGroupValue]?.improvedEnergyLabel"
              [currencyCode]="roadmapBuildingDetailsValue.currencyCode"
            />
          </div>
        </div>
      }
      <div class="row mt-4 pt-3 print-page-break-inside-avoid">
        <div class="col-12">
          <cfp-card [title]="plannedMeasuresOverviewTitleKey() | translate" [titleAllowHtml]="true">
            <ng-content select="[measuresTop]" />
            <cfp-building-measures-overview
              [showTitle]="false"
              [portfolioId]="portfolioIdValue"
              [buildingId]="buildingIdValue"
              [building]="buildingValue"
              [buildingPublicSharedId]="buildingPublicSharedIdValue"
              [measureList]="hasBuildingReportLicenseValue ? measureListFiltered() : measureListValue"
              [defaultScenario]="'planned'"
              [canEditMeasure]="canEditMeasure()"
              [showAll]="showAllMeasuresButton()"
              [showScenarios]="false"
              [showStatus]="showStatus()"
              [isPdfServiceRequest]="isPdfServiceRequestValue"
              [showInvestor]="false"
              [showImplementationYear]="false"
              [showInfo]="false"
              [showAddButton]="false"
              [showToolbar]="showToolbar()"
              [labelGroup]="labelGroupValue"
              [showMeasureDetailsButtonSidePanel]="false"
            />
            <ng-content select="[measuresBottom]" />
          </cfp-card>
        </div>
      </div>

      <div [class.d-none]="doneMeasureCount === 0" class="row mt-4 pt-3 print-page-break-inside-avoid">
        <div class="col-12">
          <cfp-card [title]="'measures.implemented' | translate">
            <cfp-building-measures-overview
              [showTitle]="false"
              [portfolioId]="portfolioIdValue"
              [buildingPublicSharedId]="buildingPublicSharedIdValue"
              [measureList]="measureListValue"
              [buildingId]="buildingIdValue"
              [building]="buildingValue"
              [canEditMeasure]="false"
              [isPdfServiceRequest]="isPdfServiceRequestValue"
              [defaultScenario]="'done'"
              [showAll]="false"
              [showScenarios]="false"
              [showStatus]="false"
              [showInfo]="false"
              [showToolbar]="false"
              [showAddButton]="false"
              [labelGroup]="labelGroupValue"
              (measureCount)="doneMeasureCount = $event"
            />
          </cfp-card>
        </div>
      </div>

      @if (
        hasBuildingReportLicenseValue &&
        roadmapBuildingDetailsValue &&
        labelGroupValue &&
        rowsValue &&
        rowsValue?.length > 0
      ) {
        <div class="row mt-4 pt-3 print-page-break-inside-avoid">
          <div class="col-12">
            <cfp-building-report-graphs
              [showGraphs]="true"
              [roadmapBuildingDetails]="roadmapBuildingDetailsValue"
              [building]="buildingValue"
            />
          </div>
        </div>
      }
      @if (buildingMeasuresForExplanationValue && buildingMeasuresForExplanationValue?.length > 0) {
        <div class="row mt-4 pt-3 print-page-break-inside-avoid">
          <div class="col-12">
            <h2 class="mt-4 pt-3 text-center">{{ 'explanation' | translate }}</h2>
            <p class="text-center mb-5">{{ 'explanation.report.measures' | translate }}</p>
            @for (
              measure of buildingMeasuresForExplanationValue
                | filter: 'buildingMeasureType' : BuildingMeasureTypeDTO.CALCULATED
                | orderBy: 'impactEnergyLabel' : true;
              track measure;
              let i = $index
            ) {
              <cfp-building-report-explanation-measure-panel
                [cardTitleClass]="'text-primary'"
                [measure]="measure"
                [showDetailsButton]="false"
                [showSummary]="false"
                [portfolioId]="portfolioIdValue"
                [buildingId]="buildingIdValue"
                [align]="i % 2 === 0 ? 'left' : 'right'"
              />
            }
          </div>
        </div>
      }
      <div class="print-page-break-inside-avoid">
        @if (numberOfLogosValue > 0) {
          <div class="mt-5 text-center">
            <span class="text-muted small">{{ 'inPartnershipWith' | translate }}:</span>
            <div class="building-report-partnership mt-4 row">
              @if (buildingReportValue?.showCfpLogo || environment.components.consultantReportDefaultShowCfpLogo) {
                <div class="col-md-{{ 12 / numberOfLogosValue }}" [class.text-md-end]="numberOfLogosValue > 1">
                  <img class="cfp-logo" src="assets/img/logo_cfp_transparent.png" alt="CFP Green Buildings" />
                </div>
              }
              @if (buildingReportValue?.hasPartnershipLogo && environment.images.consultantReportPartnershipLogo) {
                <div
                  class="mt-4 mt-md-0"
                  [class.col-md-6.text-md-start]="numberOfLogosValue === 2"
                  [class.col-md-auto]="numberOfLogosValue === 3"
                >
                  <img [src]="environment.images.consultantReportPartnershipLogo" alt="logo" />
                </div>
              }
              @if (partnershipLogoAsBase64Value) {
                <div class="col-md-{{ 12 / numberOfLogosValue }} text-md-start mt-4 mt-md-0">
                  <img [src]="partnershipLogoAsBase64Value" alt="logo" />
                </div>
              }
            </div>
          </div>
        }
        <div class="row mt-5">
          @if (showDisclaimerLink) {
            <div class="col-12">
              <p class="report-disclaimer-link" [innerHtml]="'consultantreport.disclaimer.link' | translate"></p>
            </div>
          }
          <div
            class="col-12 col-md-10 offset-md-1 text-muted text-center small"
            [innerHtml]="'consultantreport.disclaimer' | translate: { appName: environment.appName }"
          ></div>
        </div>
      </div>
      @if (showExplanationPage) {
        <div class="print-page-break-before-always d-none d-print-block">
          <div class="report-explanation-page">
            <h2 class="mb-4">Toelichtingsveld</h2>
            <div class="report-explanation-field"></div>
          </div>
        </div>
      }
    </ng-container>
    @if (showFooter) {
      <ng-container footer>
        <div
          class="text-muted text-center small mt-3"
          [innerHtml]="'consultantreport.footer' | translate | sanitizeHtml"
        ></div>
      </ng-container>
    } @else if (hasBuildingReportLicenseValue) {
      <ng-container footer>
        <cfp-building-report-footer [date]="footerDate()" />
        <ng-content select="[belowFooter]" />
      </ng-container>
    } @else {
      <div footer class="container d-none d-print-block">
        <div class="row">
          <div class="col-12 pb-2">{{ reportFooterText() }}{{ footerDateOrCurrentDate() | date: 'longDate' }}</div>
        </div>
      </div>
    }
  </cfp-printable-content>
}
